export enum StreamStatus {
  Streaming = 'streaming',
  Completed = 'completed',
  Canceled = 'canceled',
  Settled = 'settled',
}

export enum StreamEventType {
  Create = 'create_stream',
  Cancel = 'cancel_stream',
  Claim = 'claim',
  AutoClaim = 'auto_claim',
  SetAutoClaim = 'set_auto_claim',
}

export enum StreamTransactionType {
  CREATE_STREAM = 'CreateStream',
  SET_AUTO_CLAIM = 'SetAutoClaim',
  CLAIM = 'Claim',
  CLAIM_BY_PROXY = 'ClaimByProxy',
  CANCEL = 'Cancel',
}

export interface CancelStreamIntentionData {
  streamId: string;
}

export interface ClaimByProxyStreamIntentionData {
  streamId: string;
}

export interface ClaimStreamIntentionData {
  streamId: string;
}

export interface CreateStreamIntentionData {
  name: string;
  coinType: string;
  recipients: RecipientWithAmount[];
  interval: bigint;
  steps: bigint;
  startTimeMs: bigint;
  cancelable: boolean;
}

export interface RecipientWithAmount {
  address: string;
  amountPerStep: bigint;
  cliffAmount: bigint;
}

export interface SetAutoClaimIntentionData {
  streamId: string;
  enabled: boolean;
}
